/* eslint-disable no-useless-catch */
import { Injectable, inject } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { HttpService } from '@nebula-shared/data-access';
import { saveAs } from 'file-saver';
import { HttpHeaders } from '@angular/common/http';

export interface ExportarPlantillaRequest {
  tipoArchivo: 'CSV' | 'XLSX' | 'TXT';
  conEncabezado: boolean;
}

@Injectable({ providedIn: 'root' })
export class ExportarPlantillaService {
  private readonly httpService = inject(HttpService);

  async descargarPlantilla(
    tipoArchivo: 'CSV' | 'XLSX' | 'TXT' = 'XLSX',
    conEncabezado = true,
  ): Promise<void> {
    try {
      const endpoint = '/nebula-accounting-core/api/v1/causaciones/exportar-plantilla';

      let headers = new HttpHeaders();
      let extension: string;

      switch (tipoArchivo) {
        case 'XLSX':
          headers = headers.set(
            'Accept',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          );
          extension = 'xlsx';
          break;
        case 'CSV':
          headers = headers.set('Accept', 'text/csv');
          extension = 'csv';
          break;
        case 'TXT':
          headers = headers.set('Accept', 'text/plain');
          extension = 'txt';
          break;
      }

      const blob = await lastValueFrom(
        this.httpService.postBlob(
          endpoint,
          {
            tipoArchivo: tipoArchivo,
            conEncabezado: conEncabezado,
          },
          undefined,
          headers,
        ),
      );

      if (!blob || blob.size === 0) {
        throw new Error('El archivo descargado está vacío');
      }

      if (blob.type === 'text/html') {
        const text = await blob.text();
        if (text.includes('404') || text.includes('Not Found')) {
          throw new Error(`El endpoint ${endpoint} no existe`);
        }
        throw new Error('Respuesta inesperada del servidor');
      }

      const nombreArchivo = `plantilla_asiento_${this.getCurrentDate()}.${extension}`;
      saveAs(blob, nombreArchivo);
    } catch (error) {
      throw error;
    }
  }

  private getCurrentDate(): string {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day}_${hours}-${minutes}-${seconds}`;
  }
}
